// extracted by mini-css-extract-plugin
export default {"container":"primeiroAdquirenteComponentesBaseDeCalculo_container__g4exh"};